import { imageApi, queryApi } from "../../lib/api";
import { Response } from "../../lib/api/type";
import {
    CouponLookupParam,
    CouponLookupResponse,
    CourierParam,
    CourierResponse,
    ExternalSignResponse,
    ImageSetParam,
    ImageSetResponse,
    OrderSetParam,
    OrderSetResponse,
    PaymentInfoParam,
    PaymentInfoResponse,
    SetPaymentParam,
    SignParam,
    SignResponse,
} from "./type";

export const setImageMint = (data: ImageSetParam): Promise<ImageSetResponse> =>
    imageApi("image/mint/set", data);

export const getSign = (data: SignParam): Promise<SignResponse> =>
    queryApi("/oem/account/sign", data);

export const setOrderSet = (data: OrderSetParam): Promise<OrderSetResponse> =>
    queryApi("oem/order/set", data);

export const getLookupCoupon = (
    data: CouponLookupParam
): Promise<CouponLookupResponse> => queryApi("mint/coupon/get", data);

export const getPaymentsInfo = (
    data: PaymentInfoParam
): Promise<PaymentInfoResponse> => queryApi("oem/payment/get", data);

export const setOemPayment = (data: SetPaymentParam): Promise<Response> =>
    queryApi("oem/payment/set", data);

export const getExternalSign = (data: {
    external_token: string;
}): Promise<ExternalSignResponse> => queryApi("mint/account/sign", data);

export const getCourierInfo = (data: {
    order_id: number;
}): Promise<CourierResponse> => queryApi("mint/courier/get", data);

export const setOrderCourier = (data: CourierParam): Promise<Response> =>
    queryApi("mint/order/courier", data);
